import { Map } from 'immutable';
export const boiler_water_sensor_id = 20527;
export const dhw_temp_sensor_id = 20525;
export const dhw_boiler_pump_id = 20483; //Насос загрузки
export const dhw_circ_pump_id = 20484; //Насос ЦН
export const climaticOutSideSensorId = 20526;
function _conv_numbers_to_ids(ids_map_list) {
    return ids_map_list;
}
function map_getter(map) {
    return (key) => map.get(key);
}
export const boiler_id_2_relay_id = map_getter(Map(_conv_numbers_to_ids([
    [20494, 20488],
    [20495, 20489],
])));
export const boiler_id_2_adapter_slot = map_getter(Map(_conv_numbers_to_ids([
    [20494, 1],
    [20495, 2],
])));
export const heating_id_2_pump_id = map_getter(Map(_conv_numbers_to_ids([
    [20496, 20485],
    [20497, 20486],
    [20498, 20487],
    [20499, 20484],
])));
export const heating_id_2_tap_id = map_getter(Map(_conv_numbers_to_ids([
    [20496, 20491],
    [20497, 20492],
    [20498, 20493],
])));
export const heating_id_2_water_sensor_id = map_getter(Map(_conv_numbers_to_ids([
    [20496, 20522],
    [20497, 20523],
    [20498, 20524],
])));
export const hc_id_to_ai_id = Map(_conv_numbers_to_ids([
    [20496, 20530],
    [20497, 20531],
    [20498, 20532],
]));
export const heating_id_2_external_thermostat_id = map_getter(hc_id_to_ai_id);
export const heating_modes_ids = {
    comfort: 20501,
    economy: 20502,
    timetable: 20503,
    off: 20504,
    heatingDHW: 20505,
};
